import { EligibleExamActionType, HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '../../models';
import { LocDisplayType } from '../../models/display-type';
import { SYSTEM_ENUM_ROOT, SYSTEM_ENUM_TYPE } from '../shared-data';

const dpRoot = `${SYSTEM_ENUM_ROOT}|Eligible Exam Action Type`;

export type CPEligibleExamActionTypeLocs =
	| 'CPEligibleExamActionTypeEnumLiteweightRecertify'
	| 'CPEligibleExamActionTypeEnumSchedule';

export type SPEligibleExamActionTypeLocs =
	| 'SPEligibleExamActionTypeEnumLiteweightRecertify'
	| 'SPEligibleExamActionTypeEnumSchedule';

export const cpEligibleExamActionTypeEnumLocs: LocDefs<CPEligibleExamActionTypeLocs> = {
	CPEligibleExamActionTypeEnumLiteweightRecertify: {
		defaultValue: 'Liteweight Recertify',
		displayPath: `${dpRoot}|Recertify`,
		description: `System value for 'Liteweight Recertify' Eligible Exam Action Type`,
		legacyName:
			'OtherRequirement.LiteWeightRecertifyFacebook/System.Enum.EligibleExamActionType.LiteweightRecertify',
		displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
		htmlAllowed: false,
		shared: true,
		feature: HubFeature.OtherRequirementLiteWeightRecertifyFacebook,
		portal: 'CP',
	},
	CPEligibleExamActionTypeEnumSchedule: {
		defaultValue: 'Schedule',
		displayPath: `${dpRoot}|${EligibleExamActionType.Schedule}`,
		description: `System value for '${EligibleExamActionType.Schedule}' Eligible Exam Action Type`,
		legacyName: 'Exam.Scheduling/System.Enum.EligibleExamActionType.Schedule',
		displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
		htmlAllowed: false,
		shared: true,
		feature: HubFeature.ExamScheduling,
		portal: 'CP',
	},
};

export const spEligibleExamActionTypeEnumLocs: LocDefs<SPEligibleExamActionTypeLocs> = {
	SPEligibleExamActionTypeEnumLiteweightRecertify: {
		defaultValue: 'Liteweight Recertify',
		displayPath: `${dpRoot}|Recertify`,
		description: `System value for 'Liteweight Recertify' Eligible Exam Action Type`,
		legacyName:
			'OtherRequirement.LiteWeightRecertifyFacebook/System.Enum.EligibleExamActionType.LiteweightRecertify',
		displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
		htmlAllowed: false,
		shared: true,
		feature: HubFeature.OtherRequirementLiteWeightRecertifyFacebook,
		portal: 'SP',
	},
	SPEligibleExamActionTypeEnumSchedule: {
		defaultValue: 'Schedule',
		displayPath: `${dpRoot}|${EligibleExamActionType.Schedule}`,
		description: `System value for '${EligibleExamActionType.Schedule}' Eligible Exam Action Type`,
		legacyName: 'Exam.Scheduling/System.Enum.EligibleExamActionType.Schedule',
		displayType: `${SYSTEM_ENUM_TYPE}` as LocDisplayType,
		htmlAllowed: false,
		shared: true,
		feature: HubFeature.ExamScheduling,
		portal: 'SP',
	},
};

export const ELIGIBLE_EXAM_ACTION_TYPE_ENUM_LOCS = MapLocKeys<
	CPEligibleExamActionTypeLocs | SPEligibleExamActionTypeLocs
>({
	...cpEligibleExamActionTypeEnumLocs,
	...spEligibleExamActionTypeEnumLocs,
});

export type CPEligibleExamActionTypeEnumLocType = LocMap<CPEligibleExamActionTypeLocs>;
export type SPEligibleExamActionTypeEnumLocType = LocMap<SPEligibleExamActionTypeLocs>;

export const cpEligibleExamActionTypeKeys: {
	[key in EligibleExamActionType]: keyof CPEligibleExamActionTypeEnumLocType;
} = {
	[EligibleExamActionType.LiteweightRecertify]:
		ELIGIBLE_EXAM_ACTION_TYPE_ENUM_LOCS.CPEligibleExamActionTypeEnumLiteweightRecertify,
	[EligibleExamActionType.Schedule]:
		ELIGIBLE_EXAM_ACTION_TYPE_ENUM_LOCS.CPEligibleExamActionTypeEnumSchedule,
};

export const spEligibleExamActionTypeKeys: {
	[key in EligibleExamActionType]: keyof SPEligibleExamActionTypeEnumLocType;
} = {
	[EligibleExamActionType.LiteweightRecertify]:
		ELIGIBLE_EXAM_ACTION_TYPE_ENUM_LOCS.SPEligibleExamActionTypeEnumLiteweightRecertify,
	[EligibleExamActionType.Schedule]:
		ELIGIBLE_EXAM_ACTION_TYPE_ENUM_LOCS.SPEligibleExamActionTypeEnumSchedule,
};
